import { InternalApiClient } from 'lib/InternalApiClient';
import { useMemo } from 'react';

/**
 * Stable authenticated Internal API client for the component tree.
 * Auth tokens are resolved from Firebase on each request inside {@link InternalApiClient}.
 */
export const useInternalApiClient = () => {
  return useMemo(() => new InternalApiClient(), []);
};
